<template>
  <div class="text-static-default-low body-2">
    <!-- eslint-disable vue/no-v-html -->
    <!-- nosemgrep: javascript.vue.security.audit.xss.templates.avoid-v-html.avoid-v-html -->
    <div :class="$style.seo" data-selector="reviews-text" v-html="seoText" />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script setup lang="ts">
const { seoText } = defineProps<{
  seoText?: string
}>()
</script>

<style module>
.seo p,
.seo ul {
  margin-bottom: theme('spacing.16');
  list-style-type: disc;
}

.seo ul {
  padding-left: theme('spacing.28');
}
.seo h2 {
  font-weight: 600;
  font-size: 1.25rem;
}
.seo a {
  @apply body-2-link text-action-default-low;
}
</style>
